<template lang="pug">
  div.km-button.noselect(:class="{[size]: true, isBule, isBorder: isBorder === true, isBack: isBack === true}" @click="clickHandle")
    img.roate(v-if="type==='loading'" src="../../image/loading.png")
    slot
</template>

<script>
export default {
  name: 'km-button',
  props: {
    size: { default: 'normal' },
    isBorder: {
      default: -1
    },
    isBack: {
      default: -1
    },
    isBule: false,
    type: '',
    disabled: {
      default: false
    }
  },
  methods: {
    clickHandle() {
      if (this.disabled || this.type === 'loading') {
        return
      }
      this.$emit('click')
    }
  },
  mounted() {
    // console.info(this.isBorder)
  }
}
</script>

<style lang="less" scoped>
.km-button {
  cursor: pointer;
  color: #fff;
  text-align: center;
  .iconfont {
    color: #fff;
  }
  &.isBule {
    border: 1px solid #24cc7c;
    color: #24cc7c;
  }
  &.isBorder {
    border: 1px solid #ccc;
    color: #666;
  }
  &.isBorder:hover {
    border: 1px solid #24cc7c;
    color: #24cc7c;
  }
  &.isBack {
    background: #24cc7c;
    color: white;
  }
  &.isBack:hover {
    background: #21bd7c;
  }
  &.normal {
    width: 100px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    font-size: 16px;
  }
  &.bigger {
    width: 180px;
    height: 43px;
    line-height: 43px;
    border-radius: 22px;
    font-size: 18px;
  }
  &.higher {
    width: 100px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    font-size: 16px;
  }
  &.max {
    width: 330px;
    height: 50px;
    border-radius: 4px;
    font-size: 18px;
    line-height: 50px;
    background: linear-gradient(to right, #21bd73, #46bf97);
  }
}
.roate {
  vertical-align: sub;
  margin-right: 10px;
  animation: roate 3000ms linear infinite;
  width: 20px;
  height: 20px;
}
@keyframes roate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/button/main.vue